import PropTypes from 'prop-types';
import { useContext, useState } from 'react';
import MyContext from '../context/MyContext';
import texts from '../services/texts';
import Menu from './Menu';
import map from '../img/map.png';
import BurgerMenu from './BurgerMenu';

const FORM_ENDPOINT = 'https://public.herotofu.com/v1/429a3a70-64fd-11ec-b2d5-af79f33d926c';

export default function Contact({ self }) {
  const { language } = useContext(MyContext);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => setSubmitted(!submitted);

  return (
    <>
      {self && (
      <>
        <Menu />
        <BurgerMenu />
      </>
      )}
      <div className="contact-map">
        <div>
          <div className="map-container">
            <div className="contact">
              <h2>
                {texts.contact[language].h2.split('').map(
                  (letter, index) => (
                    <span className="hero" key={Math.random()} style={{ animationDelay: `${index * 70}ms` }}>
                      { letter }
                    </span>
                  ),
                )}
              </h2>
              {self && <p>{texts.contactSentence[language]}</p>}
              <form
                className="forms"
                action={FORM_ENDPOINT}
                onSubmit={handleSubmit}
                method="post"
                target="_blank"
              >
                <div className="inputs">
                  <input
                    className="contact-form"
                    type="text"
                    placeholder={texts.contact[language].name}
                    name="name"
                    required
                  />
                  <input
                    className="contact-form"
                    type="email"
                    placeholder={texts.contact[language].email}
                    name="email"
                    required
                  />
                </div>
                <div>
                  <textarea
                    className="contact-form"
                    placeholder={texts.contact[language].textArea}
                    name="message"
                    required
                  />
                </div>
                <div className="send-button">
                  <button
                    className="btn"
                    type="submit"
                    disabled={submitted}
                  >
                    <span>
                      {submitted
                        ? texts.contact[language].sendedButton
                        : texts.contact[language].button}
                    </span>
                  </button>
                </div>
              </form>
            </div>
            <div className="map">
              <img src={map} alt="map" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

Contact.propTypes = {
  self: PropTypes.bool.isRequired,
};
